<template>
  <div>
    <vx-card id="branchExtensionDataContainer" :title="$t('branch_extension')" class="mvx-8 vs-con-loading__container">
      <vs-tabs alignment="left">
        <template v-if="dids.length > 0" v-for="(did, index) in dids">
          <vs-tab :key="index" :label="did.display_name" @click.prevent="fetchDidExtension(did.did)">
            <div style="border: 1px solid #e5e5e5; padding: 10px; border-radius: 5px;" class="mt-5">
              <div class="vx-row">
                <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
                  <div>
                    <span v-text="$t('did')"/>: <span v-text="did.did" />
                  </div>
                </div>
                <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
                  <div>
                    <span v-text="$t('display_name')"/>: <span v-text="did.display_name" />
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-5" v-if="extensions.length > 0">
              <div style="background-color: dodgerblue;border-radius: 5px;display: inline-block;padding: 10px;margin: 0px 30px 0px 0px;color: white;position: relative;" v-for="(extensionData, index2) in extensions" :key="index2">
                <span style="position: absolute;color: #ffffffe6;right: -8px;top: -8px;cursor: pointer;background-color: #f94949;padding: 1px 7px;border-radius: 50%;" @click="deleteExtension(did.did, extensionData.extension)">X</span>
                <span v-text="extensionData.extension" />
              </div>
            </div>
            <div class="mt-5">
              <vs-input :label="$tc('extension', 1)" :placeholder="$tc('extension', 1)" v-model="extensionFormData.extension" class="w-full"/>
              <validation-error :model-error="extensionFormDataErrors.did"></validation-error>
            </div>
            <div class="mt-5">
              <vs-button color="primary" type="filled" @click.prevent="storeExtension(did.did)" v-text="$t('save')"></vs-button>
            </div>
          </vs-tab>
        </template>
        <vs-tab :label="$t('add_did')">
          <div class="vx-row mt-5">
            <div class="vx-col w-full">
              <div>
                <vs-input :label="$t('did')" :placeholder="$t('did')" v-model="formData.did" class="w-full"/>
                <validation-error :model-error="formDataErrors.did"></validation-error>
              </div>
            </div>
          </div>
          <div class="vx-row mt-3">
            <div class="vx-col w-full">
              <div class="mb-3">
                <vs-input :label="$t('display_name')" :placeholder="$t('display_name')" v-model="formData.display_name" class="w-full"/>
                <validation-error :model-error="formDataErrors.display_name"></validation-error>
              </div>
            </div>
          </div>
          <div class="vx-row mt-3">
            <div class="vx-col w-full">
              <vs-button color="primary" type="filled" @click.prevent="storeDid" v-text="$t('save')"></vs-button>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import BranchExtension from '@/models/BranchExtension'

export default {
  name: 'User.BranchExtension',
  data () {
    return {
      formDataErrors: {},
      formData: {},
      extensionFormDataErrors: {},
      extensionFormData: {},
      dids: {},
      extensions: []
    }
  },
  mounted () {
    this.loadBranchExtension()
  },
  methods: {
    async loadBranchExtension () {
      this.$vs.loading({container: '#branchExtensionDataContainer'})
      const response = await BranchExtension.findAll()
      this.dids = response.data.data.branchExtensions
      this.$vs.loading.close('#branchExtensionDataContainer > .con-vs-loading')
    },
    resetDidForm () {
      this.formData = {
        did: '',
        display_name: ''
      }
      this.formDataErrors = []
    },
    async storeDid () {
      this.$vs.loading({container: '#branchExtensionDataContainer'})

      try {
        const response = await BranchExtension.storeDid(this.formData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })
        this.loadBranchExtension()
        this.resetDidForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.apiKeyFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#branchExtensionDataContainer > .con-vs-loading')
    },
    resetExtensionForm () {
      this.extensionFormData = {
        did: '',
        extension: ''
      }
      this.formDataErrors = []
    },
    async storeExtension (did) {
      this.$vs.loading({container: '#branchExtensionDataContainer'})
      this.extensionFormData.did = did
      try {
        const response = await BranchExtension.storeExtension(this.extensionFormData)

        this.$swalHelper.success({
          title: this.$t('action_success'),
          text: this.$t(response.data),
          confirmButton: this.$t('confirm')
        })
        this.fetchDidExtension(did)
        this.resetExtensionForm()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.apiKeyFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#branchExtensionDataContainer > .con-vs-loading')
    },
    async fetchDidExtension (did) {
      this.$vs.loading({container: '#branchExtensionDataContainer'})
      const response = await BranchExtension.fetchDidExtension({ did })
      this.extensions = response.data
      this.$vs.loading.close('#branchExtensionDataContainer > .con-vs-loading')
    },
    async deleteExtension (did, extension) {
      const confirm = await this.$swalHelper.warning({
        title: this.$t('are_you_sure_you_want_to_delete'),
        text: this.$i18n.t('after_deletion_recovery_is_not_possible'),
        confirmButton: this.$t('execution'),
        cancelButton: this.$t('cancel')
      })

      if (confirm.value) {
        await BranchExtension.destroyExtension({ did, extension })
        this.fetchDidExtension(did)
      }
    }
  }
}
</script>

<style lang="scss">

</style>
